/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectedInstallmentInterval/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Dates from './Dates/index'
import Days from './Days/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SelectedInstallmentInterval({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/InstallmentDates/SelectedInstallmentInterval"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let newPaymentPlanSelectedInstallmentIntervalValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_installment_interval',
})
let aggregateData = fromHelpers.getView(newPaymentPlanSelectedInstallmentIntervalValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Days'}>
<Days
  viewPath={`${viewPath}/Days`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Dates'}>
<Dates
  viewPath={`${viewPath}/Dates`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}